<template>
  <form>
    <div class="lg:grid lg:grid-cols-3 gap-[25px]">
      <div class="lg:col-span-2">
        <div
          class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
        >
          <div
            class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
          >
            <div class="trezo-card-title">
              <h5 class="mb-0">{{ directT('ecommerce.createProduct.addProduct') }}</h5>
            </div>
          </div>
          <div class="trezo-card-content">
            <div v-if="loading" class="flex justify-center py-8">
              <div class="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary-500 border-r-transparent"></div>
            </div>
            <div v-else-if="error" class="p-4 bg-red-100 text-red-700 rounded mb-4">
              {{ error }}
            </div>
            <div v-else class="sm:grid sm:grid-cols-2 sm:gap-[25px]">
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.productTitle') }}
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('ecommerce.createProduct.productTitlePlaceholder')"
                  v-model="product.title"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.productType') }}
                </label>
                <select
                  class="h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
                  v-model="product.product_type"
                >
                  <option value="">{{ directT('ecommerce.createProduct.selectType') }}</option>
                  <option value="Digital Product">{{ directT('ecommerce.createProduct.digitalProduct') }}</option>
                  <option value="Physical Product">{{ directT('ecommerce.createProduct.physicalProduct') }}</option>
                </select>
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.category') }}
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('ecommerce.createProduct.categoryPlaceholder')"
                  v-model="product.category"
                />
              </div>
              <div class="sm:col-span-2 mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.description') }}
                </label>
                <textarea
                  v-model="product.description"
                  class="h-[179px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] p-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                ></textarea>
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.regularPrice') }}
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('ecommerce.createProduct.regularPricePlaceholder')"
                  v-model="product.price"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.salePrice') }}
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('ecommerce.createProduct.salePricePlaceholder')"
                  v-model="product.compare_at_price"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.productLink') }}
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('ecommerce.createProduct.productLinkPlaceholder')"
                  v-model="product.product_link"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.meetingTime') }}
                </label>
                <input
                  type="number"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.time"
                  :placeholder="directT('ecommerce.createProduct.meetingTimePlaceholder')"
                />
                <span class="text-xs text-gray-500 dark:text-gray-400 mt-1 block">
                  {{ directT('ecommerce.createProduct.meetingTimeHint') }}
                </span>
              </div>
              <div class="sm:col-span-2 mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('ecommerce.createProduct.productImage') }}
                </label>
                <div class="flex items-center gap-4">
                  <div v-if="product.image_link" class="w-24 h-24 rounded overflow-hidden">
                    <img :src="product.image_link" alt="Product image" class="w-full h-full object-cover" />
                  </div>
                  <div id="fileUploader">
                    <div
                      class="relative flex items-center justify-center overflow-hidden rounded-md py-4 px-[20px] border border-gray-200 dark:border-[#172036]"
                    >
                      <div class="flex items-center justify-center">
                        <div
                          class="w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]"
                        >
                          <i class="ri-upload-2-line"></i>
                        </div>
                        <p class="leading-[1.5]">
                          <strong class="text-black dark:text-white"
                            >{{ directT('ecommerce.createProduct.clickToUpload') }}</strong
                          ><br />
                          {{ directT('ecommerce.createProduct.image') }}
                        </p>
                      </div>
                      <input
                        type="file"
                        id="fileInput"
                        class="absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer"
                        @change="handleFileUpload"
                        accept="image/*"
                      />
                    </div>
                  </div>
                  <div v-if="uploadStatus" class="text-sm">
                    <span v-if="uploadStatus === 'uploading'" class="text-blue-500">{{ directT('ecommerce.createProduct.uploading') }}</span>
                    <span v-else-if="uploadStatus === 'success'" class="text-green-500">{{ directT('ecommerce.createProduct.uploadSuccess') }}</span>
                    <span v-else-if="uploadStatus === 'error'" class="text-red-500">{{ directT('ecommerce.createProduct.uploadFailed') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-end mt-6" v-if="!loading && !error">
            <button 
              type="button" 
              class="bg-primary-500 text-white px-6 py-2 rounded-md hover:bg-primary-600 transition-colors"
              @click="saveProduct"
            >
              {{ directT('ecommerce.createProduct.createProductButton') }}
            </button>
          </div>
        </div>
      </div>
      <div class="lg:col-span-1">
        <div
          class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
        >
          <div
            class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
          >
            <div class="trezo-card-title">
              <h5 class="mb-0">{{ directT('ecommerce.createProduct.tags') }}</h5>
            </div>
          </div>
          <div class="trezo-card-content">
            <div class="mb-[20px] md:mb-[25px] last:mb-0">
              <label
                class="mb-[10px] text-black dark:text-white font-medium block"
              >
                {{ directT('ecommerce.createProduct.tags') }}
              </label>
              <input
                type="text"
                class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                :placeholder="directT('ecommerce.createProduct.tagsPlaceholder')"
                v-model="tagsInput"
              />
              <div class="flex flex-wrap gap-2 mt-3">
                <span 
                  v-for="(tag, index) in parsedTags" 
                  :key="index"
                  class="bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded text-sm"
                >
                  {{ tag }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { supabase } from "@/lib/supabaseClient";
import { createToast } from "@/utils/toast";
import { useI18n } from 'vue-i18n';
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

interface Product {
  title: string;
  description: string;
  product_type: string;
  category: string;
  price: string;
  compare_at_price: string;
  product_link: string;
  image_link: string;
  time: string;
  tags: string[];
  org_id?: string;
}

export default defineComponent({
  name: "CreateProduct",
  setup() {
    const { t, locale } = useI18n();
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };
    
    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };
    
    const loading = ref(false);
    const error = ref<string | null>(null);
    const product = ref<Product>({
      title: "",
      description: "",
      product_type: "",
      category: "",
      price: "",
      compare_at_price: "",
      product_link: "",
      image_link: "",
      time: "",
      tags: [],
    });
    const tagsInput = ref("");
    const userOrgId = ref<string | null>(null);
    const uploadStatus = ref<'uploading' | 'success' | 'error' | null>(null);

    // Fetch user's organization ID on component mount
    onMounted(async () => {
      try {
        // Get current user from Supabase auth
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        // Get the user's organization ID
        const { data: userData, error: userError } = await supabase
          .from('user_profiles')
          .select('org_id')
          .eq('user_id', user.id)
          .single();

        if (userError) {
          console.error('Error fetching user profile:', userError);
          return;
        }

        if (userData?.org_id) {
          userOrgId.value = userData.org_id as string;
          console.log('User organization ID:', userOrgId.value);
        }
      } catch (err) {
        console.error('Error fetching user organization:', err);
      }
    });

    // Handle file upload to Supabase storage
    const handleFileUpload = async (event: Event) => {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      
      if (!file) return;
      
      try {
        uploadStatus.value = 'uploading';
        
        // Check if we have the organization ID
        if (!userOrgId.value) {
          throw new Error("Organization ID is required for uploading files");
        }
        
        // Generate a unique file name
        const fileExt = file.name.split('.').pop();
        const fileName = `${Date.now()}_${Math.random().toString(36).substring(2, 15)}.${fileExt}`;
        // Include organization ID in the file path for better organization
        const filePath = `${userOrgId.value}/${fileName}`;
        
        // Upload file to the 'productimage' bucket
        const { data, error: uploadError } = await supabase.storage
          .from('productimage')
          .upload(filePath, file, {
            cacheControl: '3600',
            upsert: false
          });
          
        if (uploadError) {
          throw uploadError;
        }
        
        // Get the public URL for the uploaded file
        const { data: { publicUrl } } = supabase.storage
          .from('productimage')
          .getPublicUrl(filePath);
          
        // Set the image link in the product data
        product.value.image_link = publicUrl;
        uploadStatus.value = 'success';
        createToast(directT('ecommerce.createProduct.uploadSuccess'), 'success');
        
      } catch (err: any) {
        console.error('Error uploading file:', err);
        uploadStatus.value = 'error';
        createToast(`${directT('ecommerce.createProduct.uploadFailed')}: ${err.message || directT('ecommerce.createProduct.unknownError')}`, 'error');
      } finally {
        // Clear the file input
        fileInput.value = '';
      }
    };

    // Converts array of tags to comma-separated string for input field
    const parsedTags = computed(() => {
      if (!tagsInput.value) return [];
      return tagsInput.value.split(",").map(tag => tag.trim()).filter(tag => tag);
    });

    const saveProduct = async () => {
      try {
        // Validate that we have an organization ID
        if (!userOrgId.value) {
          error.value = directT('ecommerce.createProduct.orgError');
          return;
        }

        loading.value = true;
        error.value = null;

        // Convert product data to database format
        const newProduct = {
          title: product.value.title,
          description: product.value.description,
          product_type: product.value.product_type,
          shopify_id: null, // Set to null instead of using product.sku
          category: product.value.category,
          price: product.value.price ? parseFloat(product.value.price) : null,
          compare_at_price: product.value.compare_at_price ? parseFloat(product.value.compare_at_price) : null,
          product_link: product.value.product_link,
          image_link: product.value.image_link,
          published_at: null, // Set to null instead of using product.publish_date
          time: product.value.time,
          tags: parsedTags.value,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          org_id: userOrgId.value,
        };

        const { error: insertError } = await supabase
          .from("products")
          .insert(newProduct);

        if (insertError) {
          throw insertError;
        }

        // Show toast notification instead of alert
        createToast(directT('ecommerce.createProduct.productCreated'), 'success');
        
        // Reset form
        product.value = {
          title: "",
          description: "",
          product_type: "",
          category: "",
          price: "",
          compare_at_price: "",
          product_link: "",
          image_link: "",
          time: "",
          tags: [],
        };
        tagsInput.value = '';
      } catch (err: any) {
        console.error('Error creating product:', err);
        error.value = err.message || directT('ecommerce.createProduct.unknownError');
      } finally {
        loading.value = false;
      }
    };

    return {
      product,
      loading,
      error,
      tagsInput,
      parsedTags,
      uploadStatus,
      handleFileUpload,
      saveProduct,
      directT,
    };
  },
});
</script>
